import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { APP_NAME, fileUrl } from '../../environment';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router'; 
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {


  // private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private snackBar = inject(MatSnackBar);
  private router = inject(Router);

  currentLanguage

  // GlobalIsForm
  isPlatformBrowserVar = isPlatformBrowser(this.platformId) ? isPlatformBrowser(this.platformId) : false
  isPlatformServerVar = isPlatformServer(this.platformId) ? isPlatformServer(this.platformId) : false

  // Switching Language Url
  urlForTheHeader = null

  // loader
  isLoading: boolean = false;

  // langCode
  localStorageLang = isPlatformBrowser(this.platformId) ? localStorage.getItem(APP_NAME + 'language') : 'ar';
  languageCode = null

  // roles
  isPatient: boolean = false
  isCenter: boolean = false
  isSponsor: boolean = false

  getFile = (name: string) => name ? fileUrl + name : ""

  constructor() { 
    // setTimeout(() => {  
    //   this.languageCode = this.router?.url?.includes('/en') ? 'en' : 'ar' 
    // }, 1000) 
  }

  showLoader = () => this.isLoading = true

  dismissLoader = () => this.isLoading = false

  getUserData = (): any => isPlatformBrowser(this.platformId) ? JSON.parse(localStorage.getItem(APP_NAME + "_UserData")) : null;

  // Global Slug
  generateSlug(inputString) {
    const decodedString = decodeURIComponent(inputString);
    let result = decodedString.toLowerCase().trim();
    result = result.replace(/ - /g, '-');
    if (result.startsWith('-')) {
      result = result.substring(1);
    }
    result = result.replace(/\s+/g, '-');
    result = result.replace(/_/g, '-');
    result = result.replace(/[/\\[\]()،,.\^+$]/g, '');
    result = result.replace(/&/g, '');
    result = result.replace(/'/g, '');
    result = result.replace(/-{2,}/g, '-');
    return result;
    // return encodeURIComponent(result);
  }

  // returns true if string contains arabic letters
  isProbablyArabic(str: string): boolean {
    var Character
    for (var i = 0; i < str?.length; i++) {
      let c = str.codePointAt(i);
      if (c >= 0x0600 && c <= 0x06E0)
        return true;
    }
    return false;
  }

  mainLogout() {
    localStorage.removeItem(APP_NAME + "_UserData");
    localStorage.removeItem(APP_NAME + "_Token");
    this.removeUserCityId();

    this.checkRole();
    if (this?.languageCode == 'en') {
      this.infoMsg("You've Been Logged Out");
    } else if (this?.languageCode == 'ar') {
      this.infoMsg("تم تسجيل الخروج");
    }
    // this.router.navigate([`/${this?.languageCode}/`]);
    window.location.href = `/${this.languageCode}`;
    this.dismissLoader();
  }

  checkRole() {
    if (isPlatformServer(this.platformId)) { return }
    const rollsArray = this.getUserData()?.roles ?? [];
    const hasUser = rollsArray.some(x => x?.name === 'User');
    const hasCenterOwner = rollsArray.some(x => x?.name === 'CenterOwner');
    const hasSponsor = rollsArray.some(x => x?.name === 'Sponsor');
    if (hasCenterOwner) {
      this.isPatient = false;
      this.isCenter = true;
      this.isSponsor = false;
      console.log("User is CenterOwner");
    } else if (hasSponsor) {
      this.isPatient = false;
      this.isCenter = false;
      this.isSponsor = true;
      console.log("User is Sponsor");
    } else if (hasUser) {
      this.isPatient = true;
      this.isCenter = false;
      this.isSponsor = false;
      console.log("User is a Patient");
    } else {
      this.isPatient = false;
      this.isCenter = false;
      this.isSponsor = false;
      console.log("User has no matching role");
    }
  }


  // snackBarsHandle
  successMsg(e) {
    if (!isPlatformBrowser(this.platformId)) { return }
    if (this?.languageCode == 'en') {
      this.snackBar.open(e, '', {
        duration: 2300,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['snack-success']
      });
    } else {
      this.snackBar.open(e, '', {
        duration: 2300,
        horizontalPosition: 'start',
        verticalPosition: 'bottom',
        panelClass: ['snack-success']
      });
    }
  }

  errorMsg(e) {
    if (!isPlatformBrowser(this.platformId)) { return }
    if (this?.languageCode == 'en') {
      this.snackBar.open(e, '', {
        duration: 2300,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['snack-error']
      });
    } else {
      this.snackBar.open(e, '', {
        duration: 2300,
        horizontalPosition: 'start',
        verticalPosition: 'bottom',
        panelClass: ['snack-error']
      });
    }
  }

  infoMsg(e) {
    if (!isPlatformBrowser(this.platformId)) { return }
    if (this?.languageCode == 'en') {
      this.snackBar.open(e, '', {
        duration: 2300,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass: ['snack-info']
      });
    } else {
      this.snackBar.open(e, '', {
        duration: 2300,
        horizontalPosition: 'start',
        verticalPosition: 'bottom',
        panelClass: ['snack-info']
      });
    }
  } 
 


  getCurrentUserLocation(): Observable<GeolocationPosition> {
    return new Observable(observer => {
      if (!navigator.geolocation) {
        observer.error('Geolocation is not supported by your browser'); 
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(position);
            observer.complete();
          },
          (error) => {
            observer.error(error)
            return error
          },
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );
      }
    });
  }


  // main city Id choosing by user
  getUserCityId = (): any => isPlatformBrowser(this.platformId) ? JSON.parse(localStorage.getItem(APP_NAME + "_MainCityId")) : null;

  setUserCityId = (cityId): any => isPlatformBrowser(this.platformId) ? localStorage.setItem(APP_NAME + "_MainCityId", cityId) : null;

  removeUserCityId = (): any => isPlatformBrowser(this.platformId) ? localStorage.removeItem(APP_NAME + "_MainCityId") : null;

}
